'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var makeProperty = function makeProperty(property) {
    return function (value) {
        return [{ property: property, value: value }];
    };
};
var makeProperties = function makeProperties(prop1, prop2) {
    return function (value) {
        return [].concat(_toConsumableArray(makeProperty(prop1)(value)), _toConsumableArray(makeProperty(prop2)(value)));
    };
};
var border = function border(key) {
    return function (value) {
        return [].concat(_toConsumableArray(makeProperty(key)(value)), _toConsumableArray(makeProperty(key)('solid')));
    };
};

var shorthands = {
    alignItems: makeProperty('align'),
    backgroundColor: makeProperty('bg'),
    border: border('b'),
    borderBottom: border('bb'),
    borderColor: makeProperty('b'),
    borderRight: border('br'),
    borderTop: border('bt'),
    borderLeft: border('bl'),
    color: makeProperty('c'),
    display: makeProperty('d'),
    flexDirection: makeProperty('flex'),
    flexWrap: makeProperty('flex'),
    fontSize: makeProperty('f'),
    fontWeight: makeProperty('fw'),
    hoverColor: makeProperty('hover'),
    justifyContent: makeProperty('justify'),
    margin: makeProperty('m'),
    marginBottom: makeProperty('mb'),
    marginLeft: makeProperty('ml'),
    marginRight: makeProperty('mr'),
    marginTop: makeProperty('mt'),
    marginX: makeProperties('ml', 'mr'),
    marginY: makeProperties('mt', 'mb'),
    mx: makeProperties('ml', 'mr'),
    my: makeProperties('mt', 'mb'),
    padding: makeProperty('p'),
    paddingBottom: makeProperty('pb'),
    paddingLeft: makeProperty('pl'),
    paddingRight: makeProperty('pr'),
    paddingTop: makeProperty('pt'),
    paddingX: makeProperties('pl', 'pr'),
    paddingY: makeProperties('pt', 'pb'),
    position: makeProperty('pos'),
    px: makeProperties('pl', 'pr'),
    py: makeProperties('pt', 'pb'),
    textAlign: makeProperty('t'),
    textTransform: makeProperty('tt'),
    verticalAlign: makeProperty('v'),
    width: makeProperty('w')
};

function parseStyle(property, value) {
    if (value === null) return null;

    var propertyMaker = shorthands[property] || makeProperty(property);

    return propertyMaker(value);
}

/**
 * This normalizes the original property rule to make sure everything is
 * converted to a shorthand class so it can be looked up in the style config.
 */
var normalize = function normalize(config) {
    return function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            property = _ref2[0],
            value = _ref2[1];

        return parseStyle(property, value, config);
    };
};

exports['default'] = normalize;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/lib/normalize.js
 ** module id = 412
 ** module chunks = 0 1
 **/